import { ReactNode } from "react";
import { TopToolbar } from "react-admin";
import { BackToEventButton } from "./BackToEventButton";

export const GameActions = ({extra}: { extra?: ReactNode[]}) =>(
    <TopToolbar sx={{ justifyContent: 'flex-start'}}>
        <BackToEventButton key={1} />
        {extra}
    </TopToolbar>
)